import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ViewChild,
	ViewEncapsulation,
	forwardRef,
	SimpleChanges,
	OnChanges,
	OnDestroy,
	AfterViewInit
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { IdService } from "../shared/services/id.service";
import { formatNumber, formatCurrency } from "../shared/utils/formatting";
import { langTypes } from "../shared/types/common";
import { FormControlBase } from "../shared/classes/form-control-base";

@Component({
	selector: "rbc-slider",
	templateUrl: "./slider.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => SliderComponent)
		}
	]
})
export class SliderComponent
	implements OnInit, OnChanges, OnDestroy, AfterViewInit {
	@Input() disabled: boolean | string = false;
	@Input() displayInput: boolean | string = false;
	@Input() displayMinMax: boolean | string = false;
	@Input() errorLabel: string;
	@Input() follow: boolean | string = false;
	@Input() formatNumberLive: boolean | string;
	@Input() helpText: string;
	@Input() id: string;
	@Input() label: string;
	@Input() legendTicker = 0;
	@Input() max: number;
	@Input() min = 0;
	@Input('value') _value = 0;
	@Input() name: string;
	@Input() step: string | number = 1;
	@Input() unit: string;
	@Input() unitPositionX: "left" | "right" = "right";
	@Input() lang: langTypes = "en";
	@Input() minLabel = "Minimum value: ";
	@Input() maxLabel = "Maximum value: ";
	@Input() status: string | boolean;
	@Input() statusType: "danger" | "success" | "warning" | "info" = "info";

	@Output() sliderUpdate = new EventEmitter();

	@Input() set value(val){
		if(!val){
			this._value = 0;
		}
		else if (val !== undefined) {
			this._value = val;
		}
		this.onChange(val);
		this.onTouched();
	};

	get value(){
		return this._value;
	}
	legends = {
		range: 0,
		interval: 0,
		middleValue: 0,
		values: []
	};
	backgroundGradient;
	widthInputRange;
	minFormatted;
	maxFormatted;
	valueFormatted;
	outputStyleRight = "";
	val = 0;
	get numberOfTicker() {
		return this.legendTicker;
	}

	get formattedValue() {
		return this.val;
	}

	set formattedValue(val) {
		this.$_Slider_updateValue2(val);
		this.val = val;
	}


	@ViewChild("inputSelector", { static: true }) $input;
	@ViewChild("outputSelector", { static: true }) $output;
	@ViewChild("inputOutput", { static: true }) $inputOutput;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnInit() {
		this.legends.range = this.max - this.min;

		// TODO: Logic here for legend values looks iffy
		if (this.legendTicker > 0) {
			this.legends.interval = this.legends.range / this.legendTicker;
			this.legends.middleValue = this.legends.range / 2;
			const upperValues = [];
			const lowerValues = [];
			for (
				let i = this.legends.middleValue;
				i <= this.max;
				i += this.legends.interval
			) {
				upperValues.push(i);
			}
			for (
				let i = this.legends.middleValue;
				i > this.min;
				i -= this.legends.interval
			) {
				if (i !== this.legends.middleValue) {
					lowerValues.push(i);
				}
			}
			lowerValues.reverse();
			this.legends.values = lowerValues.concat(upperValues);
		}

		this.minFormatted = this.$_Slider_getFormat(this.min);
		this.maxFormatted = this.$_Slider_getFormat(this.max);
		this.valueFormatted = this.getValueFormatted();

	}

	ngAfterViewInit() {
		this.$_Slider_output_FollowThumb();

	}

	ngOnChanges(changes: SimpleChanges) {
		this.$_Slider_output_FollowThumb();

		if (changes) {
			if (changes.min || changes.max) {
				this.$_Slider_backgroundGradient_update();
			}
		}
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	// returns the legal version of the value
	makeLegalValue(value) {
		if (value > this.max) {
			return this.max;
		} else if (value < this.min) {
			return this.min;
		}
		return parseInt(value, 10);
	}

	getValueFormatted() {
		return this.$_Slider_getFormat(this.value);
	}

	legendClickHandler(ticker) {
		this.$_Slider_updateValueFromLegend(ticker);
		this.$_Slider_backgroundGradient_update();
		this.val = ticker;
		// if (this.display && !this.follow) {
		// 	this.$inputOutput.text = this.$_Slider_formatNumberLive();
		// }
	}

	// Updates from input element
	$_Slider_updateValue(inputVal: string | FocusEvent) {

		const value = this.makeLegalValue(
			typeof inputVal === "string"
				? inputVal
				: (inputVal.target as any).value
		);

		this.setModel(value);
		this.$_Slider_backgroundGradient_update();
	}

	onInputBlur(evt) {
		// this.$_Slider_updateValue(evt);
		// this.touch();
		console.log(evt)
		this.writeValue(evt);
	}

	//
	$_Slider_updateValueFromLegend(ticker) {
		this.value = ticker;
		this.valueFormatted = this.getValueFormatted();
	}

	$_Slider_output_FollowThumb() {
		if (this.follow) {
			const inputWidth = this.$input.nativeElement.offsetWidth - 25;
			const inputValue = this.value;
			const inputMax = this.min;
			const inputMin = this.max;
			let outputPosition =
				(inputValue - inputMin) / (inputMax - inputMin);
			outputPosition *= inputWidth;
			this.outputStyleRight = outputPosition + "px";
		}
	}

	// Update the gradient
	$_Slider_backgroundGradient_update() {
		const val = (this.value - this.min) / (this.max - this.min);
		this.backgroundGradient =
			"linear-gradient(to right, #0051a5 " +
			val * 100 +
			"%, #b3b3b3 " +
			val * 100 +
			"%)";
	}

	$_Slider_formatNumberLive() {
		return this.$_Slider_getFormat(this.value);
	}

	$_Slider_getFormat(num) {
		const _self = this;
		if (_self.formatNumberLive) {

			num = num + "";
			const nbDecimal =
				num.split(".").length === 2 ? num.split(".")[1].length : 0;

			if (typeof _self.unit === "undefined" || _self.displayInput) {
				return formatNumber(parseFloat(num), _self.lang, nbDecimal);
			} else {
				return formatCurrency(
					parseFloat(num),
					_self.lang,
					nbDecimal,
					_self.unit
				);
			}
		} else {
			return num;
		}
	}

	setModel(val) {
		if (val > this.max) {
			val = this.max;
			this.val = val;
		} else if (val < this.min) {
			val = this.min;
			this.val = val;
		}
		this.writeValue(val);
		this.$_Slider_output_FollowThumb();
		this.$_Slider_backgroundGradient_update();
		this.val = this.valueFormatted;
		this.sliderUpdate.emit({ id: this.id, value: this.value });
	}

	// Allows Angular to update the model (rating).
	// Update the model and changes needed for the view here.
	writeValue(val): void {
		this.value = val;
		this.formattedValue = val;
		this.valueFormatted = this.getValueFormatted();

		this.$_Slider_backgroundGradient_update();
	}

	// Function to call when the rating changes.
	onChange = (rating: number) => {};
	// Function to call when the input is touched (when a star is clicked).
	onTouched = () => { };



	// Allows Angular to register a function to call when the model (rating) changes.
	// Save the function as a property to call later here.
	registerOnChange(fn: (rating: number) => void): void {
		this.onChange = fn;
	}
	// Allows Angular to register a function to call when the input has been touched.
	// Save the function as a property to call later here.
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}
	// Allows Angular to disable the input.
	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	$_Slider_updateValue2(valueToUse) {
		// const valFromText = parseInt(valueToUse.replace(/\./g, "").replace(/,/g, ""), 10);
		const valFromText = parseFloat(valueToUse);
		if (valFromText < this.min || isNaN(valFromText)) {
			this.value = this.min;
			this.val = this.min;
			// this.setModel(this.min);

		} else if (valFromText > this.max) {
			this.value = this.max;
			this.val = this.max;
			// this.setModel(this.max);

		} else {
			this.value = valFromText;
			// this.setModel(this.value);
		}

		this.$_Slider_output_FollowThumb();
		this.$_Slider_backgroundGradient_update();
		this.valueFormatted = this.getValueFormatted();
	}
}
